module.exports = __webpack_public_path__ + "media/images/event/image_02-fa24dc5ade8c34a549e7b5c161a76ee4.png";